import { createSlice } from "@reduxjs/toolkit";
import { getDateOfBirthInfo } from "./thunk";
export const initialState: any = {
  dateOfBirthData: [],
  dateOfBirthDataError: {},
};

const UserInfoSlice = createSlice({
  name: "UserInfoSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDateOfBirthInfo.fulfilled, (state: any, action: any) => {
      state.dateOfBirthData = action.payload;
    });

    builder.addCase(getDateOfBirthInfo.rejected, (state: any, action: any) => {
      state.dateOfBirthDataError = action.payload || null;
    });
  },
});

export default UserInfoSlice.reducer;
